import { ConvertHelper, TypeHelper } from "../../helpers"

import { Enums } from "../common"
import { IOpChangeState, IJsonSerializable, ICopyable } from "../util/interfaces"
import { OpOperator } from "./op-operator"
import { OpTechnicalPermission } from "./op-technical-permission"


export class OpOperatorTechnicalPermission implements IOpChangeState, IJsonSerializable, ICopyable<OpOperatorTechnicalPermission> {

    //#region Properties

    public endTime: Date
    public idOperator: number
    public idOperatorTechnicalPermission: number
    public idTechnicalPermission: number
    public notes: string
    public startTime: Date

    //#endregion


    //#region Navigation Properties

    private _operator: OpOperator = null
    public get operator(): OpOperator {
        return this._operator
    }
    public set operator(value: OpOperator) {
        this._operator = value
        this.idOperator = value != null ? value.idOperator : null
    }

    private _technicalPermission: OpTechnicalPermission = null
    public get technicalPermission(): OpTechnicalPermission {
        return this._technicalPermission
    }
    public set technicalPermission(value: OpTechnicalPermission) {
        this._technicalPermission = value
        this.idTechnicalPermission = value != null ? value.idTechnicalPermission : null
    }

    //#endregion


    //#region Custom Properties

    public dynamicValues: { Key: string; Value: any; }[];

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpOperatorTechnicalPermission) {
            this.copy(<OpOperatorTechnicalPermission>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    //#region IOpChangeState Implementation

    public opState: Enums.OpChangeState = null

    //#endregion


    //#region IJsonSerializable Implementation

    public toJSON(compressed: boolean) {
        return {
            ID_OPERATOR_TECHNICAL_PERMISSION: this.idOperatorTechnicalPermission,
            ID_OPERATOR: this.idOperator,
            ID_TECHNICAL_PERMISSION: this.idTechnicalPermission,
            START_TIME: this.startTime != null ? ConvertHelper.dateToString(this.startTime, { netFormat: true, includeTimeZone: true }) : null,
            END_TIME: this.endTime != null ? ConvertHelper.dateToString(this.endTime, { netFormat: true, includeTimeZone: true }) : null,
            NOTES: this.notes,

            _TechnicalPermission: this.technicalPermission != null ? new OpTechnicalPermission(this.technicalPermission) : null,

            OpState: this.opState
        }
    }

    public fromJSON(opObj: any, compressed: boolean = false) {
        if (opObj != null) {
            this.operator = opObj._Operator != null ? new OpOperator(opObj._Operator) : null
            this.technicalPermission = opObj._TechnicalPermission != null ? new OpTechnicalPermission(opObj._TechnicalPermission) : null

            this.idOperatorTechnicalPermission = opObj.ID_OPERATOR_TECHNICAL_PERMISSION
            this.idOperator = opObj.ID_OPERATOR
            this.idTechnicalPermission = opObj.ID_TECHNICAL_PERMISSION
            this.startTime = opObj.START_TIME != null ? ConvertHelper.stringToDate(opObj.START_TIME) : null
            this.endTime = opObj.END_TIME != null ? ConvertHelper.stringToDate(opObj.END_TIME) : null
            this.notes = opObj.NOTES
            this.opState = opObj.OpState
        } else {
            this.idOperatorTechnicalPermission = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpOperatorTechnicalPermission {
        const newOperatorTechnicalPermission: OpOperatorTechnicalPermission = new OpOperatorTechnicalPermission(null)

        newOperatorTechnicalPermission.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newOperatorTechnicalPermission
    }

    public copy(source: OpOperatorTechnicalPermission, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            if (source.technicalPermission != null) {
                this.technicalPermission = source.technicalPermission.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            }

            // No operator because of circlular reference
        }

        // No customproperties
        // No datalist


        if (includeDynamicValues) {
            this.dynamicValues = TypeHelper.clone(source.dynamicValues, true)
        }

        this.idOperatorTechnicalPermission = source.idOperatorTechnicalPermission
        this.idOperator = source.idOperator
        this.idTechnicalPermission = source.idTechnicalPermission
        this.startTime = source.startTime
        this.endTime = source.endTime
        this.notes = source.notes

        this.opState = source.opState
    }

    //#endregion


    //#region ToString

    public toString() {
        return this.notes
    }

    //#endregion
}
